<template>
    <div>

        <el-row>
            <div class="left-justifying">
                <h3>绩效 <h5><a :href="oldKpiPath">旧版绩效入口</a></h5></h3>
            </div>

            <div class="right-justifying">
                <!--                <el-button type="info" plain size="small">
                                    <i class="fa fa-plus-circle"></i> 新建
                                </el-button>
                                <el-button type="info" plain size="small">
                                    <i class="fa fa-pencil"></i> 修改
                                </el-button>
                                <el-button type="info" plain size="small">
                                    <i class="fa fa-save"></i> 保存
                                </el-button>
                                <el-button type="info" plain size="small">
                                    <i class="fa fa-times"></i> 删除
                                </el-button>-->
                <el-button @click="exportExcel" v-if="exportExcelVisible" type="info" plain size="small">
                    导出Excel
                </el-button>
                <WorkflowRequestBtn :visible="workflowBtnVisible && kpiInfo.status != 'CLOSE'"
                                    bussiness="KPI"
                                    :bussinessId="kpiInfo.id"
                                    :bussinessInfo="bussinessInfo"
                                    :errorMsg="workFlowErrorMsg"
                                    @afterRequestWorkflowFunc="afterRequestWorkflowFunc">
                </WorkflowRequestBtn>
                <WorkflowReopenBtn :visible="workflowBtnVisible && kpiInfo.status == 'CLOSE' && canReOpen"
                                   :bussiness="'KPI'"
                                   :bussinessId="kpiInfo.id"
                                   :bussinessInfo="reOpenBussinessInfo"
                                   :disabled="false"
                                   @afterRequestWorkflowFunc="afterRequestWorkflowFunc">
                </WorkflowReopenBtn>
            </div>
        </el-row>

        <div class="panel">
            <div class="panel-body">
                <el-row>
                    <div class="advanced-search-location">
                        <AthubDropDownSearch :model="searchParams" :formWidth="800" v-if="dropDownVisible" size="mini"
                                             collapseTags multiple>
                            <el-form :model="search" label-width="80px">
                                <el-row type="flex" class="row-bg">
                                    <el-col :span="11">
                                        <el-form-item label="考评月份从">
                                            <el-date-picker
                                                    size="mini"
                                                    v-model="searchParams.startdate"
                                                    type="month"
                                                    value-format="yyyy-MM-dd"
                                                    placeholder="考评月份从">
                                            </el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="11">
                                        <el-form-item label="考评月份至">
                                            <el-date-picker
                                                    size="mini"
                                                    v-model="searchParams.enddate"
                                                    type="month"
                                                    value-format="yyyy-MM-dd"
                                                    placeholder="考评月份至">
                                            </el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </AthubDropDownSearch>
                        <el-tag v-if="statusVisible" type="danger" size="mini" style="margin-top: 9px;">
                            {{kpiInfo.status | toStatusLabelFilter}}
                        </el-tag>
                    </div>
                    <el-tabs v-model="activeTab" @tab-click="handle_tab_click">


                        <el-tab-pane label="列表" name="table_tab">
                            <kpi-table :searchParams="searchParams" @showDetailTab="showDetailTab"></kpi-table>
                        </el-tab-pane>
                        <el-tab-pane label="详情" name="detail_tab">
                            <kpi-detail ref="kpiDetail"></kpi-detail>
                            <kpi-record-table ref="kpiRecordTable"
                                              @afterQueryKpiRecordTable="afterQueryKpiRecordTable"></kpi-record-table>

                            <br>

                            <el-row class="column-name" justify="start">
                                <span>本月绩效得分</span>
                            </el-row>
                            <kpi-result-table ref="kpiResultTable"></kpi-result-table>

                            <br>

                            <el-row class="column-name" justify="start" v-if="kpiInfo.id != ''">
                                <span>流转信息</span>
                            </el-row>
                            <el-row v-if="kpiInfo.id != ''">
                                <Workflow
                                        ref="kpiWorkflowInfo" bussiness="KPI"
                                        :bussinessId="kpiInfo.id">
                                </Workflow>
                            </el-row>

                        </el-tab-pane>

                    </el-tabs>

                </el-row>
            </div>
        </div>

        <WorkflowDialog
                bussiness="KPI"
                statusName="athubStatus"
                ref="workflowDialog"
                :bussinessId="kpiInfo.id"
                :workflowRequestInfo="workflowRequestInfo"
                :dialogWorkflowVisible.sync="workflowDialogVisible"
                @afterAuditWorkflowFunc="afterAuditWorkflowFunc">
        </WorkflowDialog>

        <kpi-result-export-dialog :kpiResultExportDialogVisible.sync="kpiResultExportDialogVisible"></kpi-result-export-dialog>

    </div>
</template>

<script type="text/javascript">

    import DeptSelect from '@/components/dept'
    import AthubDropDownSearch from '@/components/common/athub.dropdown.search'
    import KpiTable from './kpiTable'
    import KpiDetail from './kpiDetail'
    import KpiRecordTable from './kpiRecordTable'
    import KpiResultTable from './kpiResultTable'
    import KpiResultExportDialog from './kpiResultExportDialog'

    import KpiServer from '@/api/kpi/index'

    import {createNamespacedHelpers} from 'vuex'

    import Workflow from '@/components/workflow'
    import WorkflowDialog from '@/components/workflow/workflowDialog'
    import WorkflowRequestBtn from '@/components/workflow/workflowRequestBtn'
    import WorkflowReopenBtn from '@/components/workflow/workflowReopenBtn'
    import WorkflowApi from '../../api/workflow/workflow'
    import {ATHUB_CLOUD_SERVER} from '../../api/server'

    let that;
    const kpiNSHelper = createNamespacedHelpers("kpi");

    export default {
        name: 'kpi',

        components: {
            DeptSelect,
            AthubDropDownSearch,
            KpiTable,
            KpiDetail,
            KpiRecordTable,
            KpiResultTable,
            KpiResultExportDialog,

            Workflow,
            WorkflowDialog,
            WorkflowRequestBtn,
            WorkflowReopenBtn,
        },

        data() {

            return {

                oldKpiPath:  `${ATHUB_CLOUD_SERVER}/room/evaluate-stat.do?m=140704`,

                //列表页面高级查询框
                dropDownVisible: true,

                //列表页面工作流状态
                statusVisible: true,

                //工作流相关
                workflowBtnVisible: true,

                workflowDialogVisible: false,

                bussinessInfo: {},  //请求工作流附加的一些参数，在保存、修改时都需要上送

                workFlowErrorMsg: '',

                workflowRequestInfo: {},    //审批工作流时包含请求工作流返回的结果：后一节点，wfToken

                KPI_PERMISSION_REOPEN: 'menu.kpi.reopen',

                canReOpen: true, //是否可以重新审核

                statusList: [
                    {
                        value: 'DRAFT',
                        desc: '草稿'
                    },
                    {
                        value: 'WHANDLE',
                        desc: '待处理'
                    },
                    {
                        value: 'WAPPROVE',
                        desc: '待审批'
                    },
                    {
                        value: 'CLOSE',
                        desc: '完工'
                    },
                ],

                //当前Tab页
                activeTab: "table_tab",

                //导出按钮可见状态
                exportExcelVisible: true,

                //导出Excel模态框可见状态
                kpiResultExportDialogVisible: false,

                //主表单查询条件
                searchParams: {
                    startdate: null,
                    enddate: null,
                },

                reOpenBussinessInfo: {
                    params: JSON.stringify({'STATUS': 'CLOSE'}),
                }
            }

        },

        methods: {

            handle_tab_click(tab, event) {
                this.activeTab = tab.name;
            },

            showDetailTab() {
                this.activeTab = "detail_tab";
            },

            afterQueryKpiRecordTable() {
                this.$refs['kpiResultTable'].queryTable();
            },

            afterRequestWorkflowFunc(params) {
                this.workflowRequestInfo = params;
                this.workflowDialogVisible = true;
            },

            afterAuditWorkflowFunc(params) {
                params.params = JSON.stringify({
                    DEPTID: this.kpiInfo.deptid
                });
                let nextStatus = '';
                WorkflowApi.audit(params).then(responseBody => {
                    if (responseBody.code == 'OK') {
                        nextStatus = responseBody.athubStatus;

                        //3350 【功能】绩效管理——考评责任人现在按照M3机房经理取值，有一些机房没有M3职位（上海1号），还有一些机房没有M3职位，右其他机房经理处理（536）
                        if (that.kpiInfo.owner == 'admin' && nextStatus == 'WAPPROVE') {
                            that.kpiInfo.owner = localStorage.getItem("realname");
                        }

                        return KpiServer.kpi.update(that.kpiInfo.id, {
                            id: that.kpiInfo.id,
                            status: nextStatus,
                            owner: that.kpiInfo.owner
                        });
                    } else {
                        this.$message.error(responseBody.message);
                        return;
                    }
                }).then(responseBody => {
                    if (responseBody.data.code == 200) {
                        this.kpiInfo.status = nextStatus;

                        if (nextStatus == 'CLOSE' || nextStatus == 'WAPPROVE') {
                            that.$refs.kpiRecordTable.operFlag = false;
                        }

                        that.$refs.kpiWorkflowInfo.getHistoryList();
                        that.$message.success('工作流发送成功');

                        that.$refs.kpiDetail.kpiDetailInfo.owner = that.kpiInfo.owner;

                        that.$refs.workflowDialog.close();

                    }
                }).catch(error => {
                    that.$message.error(error);
                    return;
                });
            },

            exportExcel(){
                this.kpiResultExportDialogVisible = true;
            },

        },

        computed: {
            ...kpiNSHelper.mapGetters(['kpiInfo']),
        },

        watch: {
            kpiInfo: {
                deep: true,
                handler: function (newVal, oldVal) {
                    if (newVal.status == 'DRAFT' || newVal.status == 'WAPPROVE') {
                        this.bussinessInfo = {
                            'params': JSON.stringify({'STATUS': 'DRAFT'}),
                        }
                    }
                }
            },

            activeTab: {
                immediate: true,
                deep: true,
                handler: function (newVal, oldVal) {
                    if (newVal == 'table_tab') {
                        this.dropDownVisible = true;
                        this.workflowBtnVisible = false;
                        this.statusVisible = false;
                        this.exportExcelVisible = true;
                    } else if (newVal == 'detail_tab') {
                        this.dropDownVisible = false;
                        this.workflowBtnVisible = true;
                        this.statusVisible = true;
                        this.exportExcelVisible = false;
                    }
                    this.canReOpen = this.hasPermission(this.KPI_PERMISSION_REOPEN);
                    // this.canReOpen = true;
                }
            }
        },

        beforeCreate() {
            that = this;
        },

        filters: {

            toStatusLabelFilter(value) {
                let desc = '草稿';
                that.statusList.forEach(e => {
                    if (e.value == value) {
                        desc = e.desc;
                        return;
                    }
                })
                return desc;
            },

        },

    }

</script>